<template>
  <div class="lesson-attendance-overview">
    <ag-grid-table
      class="ag-grid"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :paginate="false"
      :fit-cols="false"
      :filter="true"
      :search="true"
      :explanation="true"
      @gridSizeChanged="gridSizeChanged"
      @showFilter="showFilterChange"
    >
      <template slot="filter">
        <slot
          name="filter"
        />
      </template>
      <template slot="explanation">
        <div style="text-align: center;">
          <a
            style="cursor: pointer"
            @click="showDetails = true"
          >
            <span
              id="explanation_chevron"
              class="fa fa-info-circle"
            /> {{ trans('core.explanation') }}
          </a>
        </div>
      </template>
    </ag-grid-table>

    <modal
      v-if="showDetails"
      :open="showDetails"
      :title="trans('core.explanation')"
      style="text-align:left; z-index: 9999999999"
      @close="showDetails = false"
    >
      <p>
        {{ trans('courses.matrixsplitoverview_explanation') }}
      </p>
      <div>
        <table style="margin: 0 15px; width:30% ">
          <tr>
            <td>
              <div
                class="cell"
                style="color:white;background:#117733;width:24px;height:24px;margin: 2px 0;"
              >
                <span
                  class="fa fa-check detailsbutton"
                  aria-hidden="true"
                />
              </div>
            </td>
            <td class="py-2">
              {{ trans('core.attended') }}
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="cell"
                style="color:white;background:#9acd32;width:24px;height:24px;margin: 1px;"
              >
                <span
                  class="fa fa-check"
                  aria-hidden="true"
                />
              </div>
            </td>
            <td class="py-2">
              {{ trans('core.attended_outside_schedule') }}
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="cell"
                style="color:white;background:#882255;width:24px;height:24px;margin: 1px;"
              >
                <span
                  class="fa fa-remove"
                  aria-hidden="true"
                />
              </div>
            </td>
            <td class="py-2">
              {{ trans('core.absent') }}
            </td>
          </tr>

          <tr>
            <td>
              <div
                class="cell"
                style="color:white;background:#882255;width:24px;height:24px;margin: 1px;"
              >
                <span
                  class="fa fa-circle-o"
                  aria-hidden="true"
                />
              </div>
            </td>
            <td class="py-2">
              {{ trans('core.noticed_absent') }}
            </td>
          </tr>

          <tr>
            <td>
              <div
                class="cell"
                style="color:white;background:#808080;width:24px;height:24px;margin: 1px;"
              >
                <span
                  class="fa fa-minus"
                  aria-hidden="true"
                />
              </div>
            </td>
            <td class="py-2">
              {{ trans('core.excused') }}
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="cell"
                style="color:white;background:#88CCEE;width:24px;height:24px;margin: 1px;"
              >
                &nbsp;
              </div>
            </td>
            <td class="py-2">
              {{ trans('core.future') }}
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="cell"
                style="border-color:#808080; border-style: solid; border-widht: 3px;height:24px;width:24px;margin: 1px;"
              />
            </td>
            <td class="py-2">
              {{ trans('core.not_in_schedule') }}
            </td>
          </tr>
        </table>
      </div>
    </modal>

    <modal
      v-if="openModal"
      :open="openModal"
      :title="trans('core.dossier')"
      style="text-align:left; z-index: 9999999999"
      @close="closeModal"
    >
      <h4> {{ trans('student.dossier_at_event', { event: selectedEvent.name, student: selectedStudent.name }) }} </h4>
      <table
        class="table"
        style="margin-top: 10px;"
      >
        <tr>
          <th>{{ trans('core.date') }}</th>
          <td>{{ selectedEvent.displayDate }}</td>
        </tr>
        <tr>
          <th>{{ trans('core.status') }}</th>
          <td>{{ getAttendedStatusString(selectedStatus) }}</td>
        </tr>
      </table>

      <template v-if="selectedRemarks.length > 0">
        <br>
        <h4> {{ trans_choice('core.remarks', 2) }} </h4>

        <table
          class="table"
          style="margin-top: 10px;"
        >
          <tr>
            <th> {{ trans('core.remark') }} </th>
            <th> {{ trans('core.date') }} </th>
            <th> {{ trans('core.author') }} </th>
          </tr>
          <tr
            v-for="remark in selectedRemarks"
            :key="remark.id"
          >
            <td> {{ remark.remark }} </td>
            <td> {{ moment(remark.created_at).format('DD-MM HH:mm') }} </td>
            <td> {{ remark.author ? remark.author : '-' }} </td>
          </tr>
        </table>
      </template>

      <button
        type="button"
        class="btn btn-default pull-right"
        @click="closeModal"
      >
        {{ trans('core.close') }}
      </button>
      <br style="clear:both">
    </modal>
  </div>
</template>

<script>
import 'ag-grid-community/styles/ag-grid.css'
import AgGridTable from '@/employees/components/AgGridTable'
import Modal from '@/employees/AttendanceList/components/Modal'
import AttendanceMatrixHeader from '@/employees/components/Lessons/AttendanceMatrixHeader'
import { mapState } from 'vuex'
import { ABSENT, ATTENDED, ATTENDED_NOT_SCHEDULE, EXCUSED, FUTURE, NOTICED_ABSENT } from '@/constants'
import groupBy from 'lodash/groupBy'
import uniq from 'lodash/uniq'
import orderBy from 'lodash/orderBy'
import escape from 'lodash/escape'
import moment from 'moment'

export default {
  name: 'AttendanceMatrixSplitOverview',

  components: { AgGridTable, Modal, AttendanceMatrixHeader },

  props: {
    events: {
      required: true,
      type: Array,
    },
    students: {
      required: false,
      type: Array,
      default: null,
    },
  },

  data () {
    return {
      gridOptions: {
        defaultColDef: {
          sortable: false,
          resizable: false,
        },
        headerHeight: 60,
        rowBuffer: 25,
        rowHeight: 60,
        suppressCellFocus: true,
        suppressHeaderFocus: true,
        enableBrowserTooltips: true,
        pagination: false,
      },
      pinning: true,
      selectedStudent: null,
      selectedEvent: null,
      selectedStatus: null,
      selectedRemarks: [],
      openModal: false,
      showDetails: false,
    }
  },

  computed: {
    ...mapState({
      storeStudents (state) {
        return state.students.students
      },
      allEvents (state) {
        return state.events.events
      },
      eventStudents (state) {
        return Object.values(state.events.event_students)
      },
      contexts (state) {
        return state.events.student_event_contexts
      },
      groups (state) {
        return state.groups.groups
      },
    }),

    eventGroupIds () {
      const ids = Object.values(this.allEvents).map(event => event.groups).flat()

      return uniq(ids)
    },

    eventsGroupedByDate () {
      if (this.events) {
        const eventsGroupedByDate = groupBy(this.events.map(event => {
          return {
            ...event,
            date: moment(event.starttime).format('YYYY-MM-DD'),
          }
        }), 'date')

        const eventsGroupedByAndSortedByDate = Object.entries(eventsGroupedByDate)
          .sort(([keyA, propertyA], [keyB, propertyB]) => moment(keyA).diff(moment(keyB)))
          .reduce((r, [k, v]) => ({ ...r, [k]: v }), {})

        const newObject = {}

        for (const [key, events] of Object.entries(eventsGroupedByAndSortedByDate)) {
          newObject[key] = events
          newObject[key].date = key
        }

        return newObject
      }
      return {}
    },

    columnDefs () {
      const newColumns = Object.entries(this.eventsGroupedByDate).map(([key, value]) => ({
        headerName: moment(value.date).format('DD-MM-YYYY'),
        field: key,
        cellRenderer: this.renderAttendedCell,
        headerComponentParams: { id: key, name: key, date: key },
        cellClass: 'status',
        getQuickFilterText: () => null,
        width: value.length * 32,
        cellStyle: this.cellStyle,
      }))

      return [
        {
          headerName: Lang.get('core.name'),
          field: 'name',
          pinned: 'left',
          cellRenderer: this.renderStudentCell,
          valueFormatter: params => params.value.name,
          getQuickFilterText: (params) => {
            return params.value
          },
          cellStyle: this.cellStyle,
        },
        ...newColumns,
        {
          headerName: Lang.get('core.total'),
          field: 'totals',
          pinned: this.pinning ? 'right' : null,
          width: 100,
          cellStyle: this.cellStyle,
        },
      ]
    },

    cellStyle () {
      return { 'font-size': '14px', padding: '5px', 'font-family': 'Roboto' }
    },

    rowData () {
      const studentEventData = groupBy(this.eventStudents, 'student_id')

      return this.sortedStudents.map((student) => {
        const newAttendanceRows = []
        let max = 0
        let attended = 0

        Object.entries(this.eventsGroupedByDate).map(([key, value]) => {
          newAttendanceRows[key] = {
            student_id: student.id,
            events: value.map(event => {
              const attendanceData = studentEventData[student.id] != null ? studentEventData[student.id].find(data => data.event_id == event.id) : null
              const studentEventContexts = event.contexts.map(contextId => this.contexts[contextId]).filter(context => context.student_id == student.id)
              let attendedStatus = null

              if (attendanceData && attendanceData.attended) {
                if (attendanceData.should_attend) {
                  attendedStatus = ATTENDED
                } else {
                  attendedStatus = ATTENDED_NOT_SCHEDULE
                }
                attended++
                max++
              } else if (moment(event.starttime).unix() > moment().unix() && attendanceData && attendanceData.should_attend) {
                attendedStatus = FUTURE
              } else if (studentEventContexts.some((studentEventContext) => studentEventContext.context_type === NOTICED_ABSENT)) {
                attendedStatus = NOTICED_ABSENT
              } else if (attendanceData && attendanceData.should_attend && !attendanceData.attended) {
                attendedStatus = ABSENT
                max++
              } else if (attendanceData && attendanceData.excused) {
                attendedStatus = EXCUSED
              }

              return {
                event_id: event.id,
                student_id: student.id,
                attended_status: attendedStatus,
                remarks: studentEventContexts,
              }
            }),
          }

          return {
            name: student,
            ...newAttendanceRows,
          }
        })

        return {
          name: student,
          ...newAttendanceRows,
          totals: `${attended} / ${max}`,
        }
      })
    },

    sortedStudents () {
      // use the given students if applicable
      if (this.students) {
        return orderBy(this.students, 'lastName')
      }

      return orderBy(Object.values(this.storeStudents), 'lastName')
    },
  },

  methods: {
    renderAttendedCell (data) {
      const div = document.createElement('div')
      div.className = 'd-flex justify-content-around w-100'

      for (let i = 0; i < data.value.events.length; i++) {
        div.appendChild(this.getEventStatusDiv(data.value.events[i]))
      }

      return div
    },

    getEventStatusDiv (eventData) {
      const div = document.createElement('div')
      div.className = 'cell'
      const status = eventData.attended_status
      const remarkCount = eventData.remarks.length

      const remarkCountAtrr = `data-count="${remarkCount}"`
      const classname = (remarkCount !== 0 ? ' fa-icon-badge' : '')
      const style = 'position: relative; cursor:pointer; width:14px'

      const tooltip = this.getTooltip(eventData)
      if (status === ATTENDED) {
        div.style = 'background:#117733; color:white'
        div.innerHTML = `<span class="fa fa-check ${classname} detailsbutton" style="${style}" aria-hidden="true" ${remarkCountAtrr}
        title="${tooltip}"></span>`
      } else if (status === ATTENDED_NOT_SCHEDULE) {
        div.style = 'background:#9acd32;; color:white'
        div.innerHTML = `<span class="fa fa-check ${classname} detailsbutton" style="${style}" aria-hidden="true" ${remarkCountAtrr}
         title="${tooltip}"></span>`
      } else if (status === ABSENT) {
        div.style = 'background:#882255; color:white'
        div.innerHTML = `<span class="fa fa-remove ${classname} detailsbutton" style="${style}" aria-hidden="true" ${remarkCountAtrr}
         title="${tooltip}"></span>`
      } else if (status === NOTICED_ABSENT) {
        div.style = 'background:#882255; color:white'
        div.innerHTML = `<span class="fa fa-circle-o ${classname} detailsbutton" style="${style}" aria-hidden="true" ${remarkCountAtrr}
         title="${tooltip}"></span>`
      } else if (status === EXCUSED) {
        div.style = 'background:#808080; color:white'
        div.innerHTML = `<span class="fa fa-minus ${classname} detailsbutton" style="${style}" aria-hidden="true" ${remarkCountAtrr}
         title="${tooltip}"></span>`
      } else if (status === FUTURE) {
        div.style = 'background:#88CCEE; color:white; border-color:#88CCEE; border-style: solid; border-widht: 3px;'
        div.innerHTML = `<span class="detailsbutton" style="position: relative; cursor:pointer; width:8px; height: 8px;" aria-hidden="true" title="${tooltip}"/>`
      } else {
        div.style = 'border-color:#808080; border-style: solid; border-widht: 3px;'
        div.innerHTML = `<div style="position: relative; cursor:pointer; width:8px; height: 8px;" aria-hidden="true" title="${tooltip}" ${remarkCountAtrr}/>`
      }

      const button = div.querySelectorAll('.detailsbutton')[0]

      if (button !== undefined) {
        button.addEventListener('click', () => {
          this.selectedStudent = this.students.find(student => student.id == eventData.student_id)
          this.selectedEvent = this.allEvents[eventData.event_id]
          this.selectedRemarks = eventData.remarks
          this.selectedStatus = status
          this.openModal = true
        })
      }

      return div
    },

    renderStudentCell (student) {
      const div = document.createElement('div')

      const groupNames = student.value.groups.filter(groupId => this.eventGroupIds.includes(groupId)).map(groupId => this.groups[groupId].name).join(', ')

      div.innerHTML = `<span class="studentbutton" style="cursor:pointer"><b>${escape(student.value.name)}</b>` + (groupNames.length < 1 ? '' : `<br><small>${escape(groupNames)}</small></span>`)

      if (student.value.link) {
        const button = div.querySelectorAll('.studentbutton')[0]

        button.addEventListener('click', function () {
          window.open(student.value.link)
        })
      }

      return div
    },

    getNameFilter (student) {
      return student.value.name
    },

    gridSizeChanged (data) {
      const availableWidth = data.clientWidth
      const totalColumnWidth = data.api.getAllDisplayedColumns()
        .reduce((total, column) => total + column.actualWidth, 0)

      this.pinning = availableWidth < totalColumnWidth
    },

    getAttendedStatusString (status) {
      if (status === ATTENDED) {
        return Lang.get('core.attended')
      } else if (status === ATTENDED_NOT_SCHEDULE) {
        return Lang.get('core.attended_outside_schedule')
      } else if (status === ABSENT) {
        return Lang.get('core.absent')
      } else if (status === NOTICED_ABSENT) {
        return Lang.get('core.noticed_absent')
      } else if (status === EXCUSED) {
        return Lang.get('core.excused')
      } else if (status === FUTURE) {
        return Lang.get('core.future')
      } else {
        return '-'
      }
    },
    getTooltip (eventData) {
      const event = this.allEvents[eventData.event_id]
      return event.name + ' \n' + moment(event.starttime).format('DD-MM-YYYY HH:mm') + '\n' + this.getAttendedStatusString(eventData.attended_status)
    },

    closeModal () {
      this.selectedStudent = null
      this.selectedEvent = null
      this.selectedRemarks = []
      this.selectedStatus = null
      this.openModal = false
    },
    showFilterChange (event) {
      this.$emit('showFilter', event)
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/
.ag-header-cell{
  display: flex;
  justify-content: center;
}
</style>

<style lang="scss">
  .lesson-attendance-overview {
    flex: 0 1 auto;
    display: flex;
    flex-direction: column;
    height: inherit;
    .ag-grid {
      display: flex;
      flex: 1 1 auto;
      overflow-y: auto;
      overflow-x: auto;
      height: inherit;
    }

    .ag-row .ag-cell {
      display: flex;
      align-items: center;
      &.status {
        justify-content: center; /* align horizontal */
      }
    }
    .ag-row {
      border-top: 1px solid #dee2e6;
    }
    .ag-cell {
      line-height: 20px !important;
    }
    .ag-horizontal-left-spacer, .ag-horizontal-right-spacer {
      visibility: hidden;
    }
  }

  /* badge counter */
  .fa-icon-badge:after {
    content: attr(data-count);
    font-family: Roboto, Helvetica, Arial, sans-serif;
    position: absolute;
    background: rgba(0, 0, 0, 1);
    height: 1.3rem;
    top: 0.3rem;
    right: -0.4rem;
    width: 1.3rem;
    padding-right: 0.1rem;
    padding-left: 0.0rem;
    text-align: center;
    line-height: 1.1rem;
    font-size: 1.1rem;
    border-radius: 50%;
    color: white;
    border: 1px solid rgba(0, 0, 0, 1);
  }

  .cell {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding:5px;
    border-radius: 3px;
  }
</style>
